




















import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { MCCreate,MCUpdate } from '@/api'
import { ElForm } from 'element-ui/types/form'
import { VTable, TableHander } from '@/components/table'
import { VImageUpload } from '@/components/upload'
import { TxLocal } from '@/utils/local/TxLocal'

@Component({
  components: {
    VTable,
    VImageUpload,
  },
})
export default class EditMedicineCabineDialog extends Vue {
  @Prop({ type: Boolean, default: false }) private appendToBody!: boolean

  @Emit('close')
  private close() {
    const f = this.$refs.form as ElForm
    f.resetFields()
    this.show = false
  }
  private data: any = {}
  private show = false
  private isEdit = false
  
  public async open(data: any, isEdit: boolean) {
    this.show = true
    this.data = data
    this.isEdit = isEdit
    // 加载绑定商品

    if (this.data.logo) {
      this.data.logoList = this.data.logo.split(',').map((e: string) => {
        return { url: e }
      })
    } else {
      this.data.logoList = []
    }
    
  }

  private requiredRule = { required: true, message: '不能为空', trigger: 'blur' }
  private rules = {
    name: [this.requiredRule],
    deviceId: [this.requiredRule],
    supplierName: [this.requiredRule],
    address: [this.requiredRule],
  }

  public async save() {

    this.data.logo = this.data.logoList.map((e: any) => e.url).join(',')

    const form = this.$refs.form as ElForm
    form.validate(async (valid: boolean) => {
      if (valid) {
        // 获取经纬度
        const location = await TxLocal.getLal(this.data.address)
        this.data.longitude = location.location.lng
        this.data.latitude = location.location.lat

        console.log(this.data)

        let result = {}
        if(this.isEdit){
          result = await MCUpdate(this.data)
        } else {
          result = await MCCreate(this.data)
        }
        console.log(result)
        if(result){
          this.close()
        }
        
      } else {
        return false
      }
    })
  }
}
